<script>
import tourMixin from '@src/mixins/tour'

import lazyLoadComponent from '@router/lazyload-component'

import { merchantComputed } from '@state/helpers'

import { cities as TaiwanCity } from '@utils/taiwan-city-area'

export default {
  components: {
    BaseInputFloatingLabel: () =>
      lazyLoadComponent(import('@components/BaseInputFloatingLabel')),
    BaseUpload: () => lazyLoadComponent(import('@components/BaseUpload')),
    CountryCodePicker: () =>
      lazyLoadComponent(import('@components/CountryCodePicker')),
  },
  mixins: [tourMixin],
  tourName: 'merchantInfo',
  data() {
    return {
      TaiwanCityList: Object.freeze(TaiwanCity),
      tryingToStore: false,
      submitData: '',
    }
  },
  computed: {
    ...merchantComputed,
  },
  created() {
    this.submitData = JSON.parse(JSON.stringify(this.currentMerchant))
  },
  methods: {
    async tryToStore() {
      this.tryingToStore = true
      await this.$store.dispatch('merchant/store', this.submitData)
      this.$message({
        message: '儲存成功！',
        type: 'success',
      })
      this.updateMerchantCached()
      this.tryingToStore = false
    },
    async updateMerchantCached() {
      await this.$store.dispatch('merchant/fetchSingle')
    },
  },
}
</script>

<template>
  <el-form
    ref="infoForm"
    :model="submitData"
    label-position="top"
    class="el-form--floating"
  >
    <h4
      data-tour-text="在這裡設定你的商店 Logo 圖與首頁封面圖"
      class="form-block-title"
      >Logo 與首頁封面圖</h4
    >
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="Logo 圖" prop="logo">
          <BaseUpload v-model="submitData.logo" resource="merchant" />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="首頁封面圖" prop="image">
          <BaseUpload v-model="submitData.image" resource="merchant" />
        </el-form-item>
      </el-col>
    </el-row>

    <h4
      data-tour-text="更改設定商店的名字、介紹文字與聯絡資訊"
      class="form-block-title"
      >基本資訊</h4
    >
    <el-form-item label="您的專屬訂購頁網址">
      <div>{{ merchantUrl }}</div>
    </el-form-item>
    <el-form-item label="商店名稱" prop="name">
      <BaseInputFloatingLabel v-model="submitData.name" />
    </el-form-item>

    <el-form-item label="商店介紹" prop="description">
      <BaseInputFloatingLabel
        v-model="submitData.description"
        type="textarea"
        :autosize="{ minRows: 2 }"
      />
    </el-form-item>
    <el-form-item label="聯繫電話" prop="phoneNumber">
      <el-input v-model="submitData.phoneNumber">
        <CountryCodePicker slot="prepend" v-model="submitData.phoneCode" />
      </el-input>
    </el-form-item>
    <el-form-item label="聯繫 Email" prop="email">
      <BaseInputFloatingLabel v-model="submitData.email" />
    </el-form-item>

    <el-form-item label="國別" prop="country">
      <el-select v-model="submitData.country">
        <el-option label="臺灣" value="臺灣"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="城市" prop="city">
      <el-select v-model="submitData.city">
        <el-option
          v-for="city in TaiwanCityList"
          :key="city.CityName"
          :label="city.CityName"
          :value="city.CityName"
        ></el-option>
      </el-select>
    </el-form-item>

    <el-form-item label="地址" prop="address">
      <BaseInputFloatingLabel v-model="submitData.address" />
    </el-form-item>
    <h4 class="form-block-title">社群／行銷</h4>
    <el-form-item label="官方 LINE@ 帳號" prop="lineId">
      <BaseInputFloatingLabel v-model="submitData.lineId" />
    </el-form-item>
    <el-form-item
      label="Google Analytics 追蹤 ID（UA-XXXXXXXXX-X）"
      prop="ga"
      :rules="{
        pattern: /UA-\d{4,10}-\d{1,4}/,
        message: '請填寫有效的追蹤 ID',
        trigger: 'blur',
      }"
    >
      <BaseInputFloatingLabel v-model="submitData.ga" />
    </el-form-item>
    <h4 class="form-block-title">電子發票設定</h4>
    <el-row :gutter="20">
      <el-col :span="8">
        <el-form-item label="發票開立類型" prop="tax.type">
          <el-select
            v-model="submitData.tax.type"
            placeholder="請選擇發票開立類型"
          >
            <el-option label="個人" value="B2C"></el-option>
            <el-option label="企業" value="B2B"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item
          label="公司抬頭"
          prop="tax.title"
          :rules="[
            {
              required: submitData.tax.type === 'B2B',
              message: '請填寫公司抬頭',
            },
          ]"
        >
          <BaseInputFloatingLabel v-model="submitData.tax.title" />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item
          label="公司統一編號"
          prop="tax.id"
          :rules="[
            {
              required: submitData.tax.type === 'B2B',
              message: '請填寫公司統一編號',
            },
            { pattern: /^\d{8}$/, message: '請填寫正確的統一編號' },
          ]"
        >
          <BaseInputFloatingLabel v-model="submitData.tax.id" />
        </el-form-item>
      </el-col>
    </el-row>
    <el-button
      data-tour-text="欄位修改後，記得儲存資料。"
      type="primary"
      class="is-fullwidth"
      :loading="tryingToStore"
      @click="tryToStore"
      >儲存變更</el-button
    >
  </el-form>
</template>
